<template>
  <!-- 总体 -->
  <div class="NewsCenterDetails" style="align-self: center;">
    <!-- 标题 -->
    <div class="flex-all-center flex-column mt-76">
      <p class="titletext">{{ $t('newsCenterDetails5.text1') }}</p>
      <p class="titletext">{{ $t('newsCenterDetails5.text2') }}</p>
    </div>

       <!-- 标题下图标 -->
    <div class="timeandaddress flex-all-center">
        <div class="mr-6"><img src="../../assets/images/time_icon.png" class="iconimg "></div>
        <div class="mr-38">{{ $t('newsCenterDetails5.text2_1') }}</div>
        <div class="mr-6"><img src="../../assets/images/postion_icon.png" class="iconimg"></div>
        <div>{{ $t('newsCenterDetails5.text3') }}</div>
    </div>
       <!-- 正文 -->
    <div class="main">
    <div class="maincontent">
      <div class="textlayout">
        <p>{{ $t('newsCenterDetails5.text4') }}</p>
      </div>
        
      <div class="textlayout">
        <img class="picimg" src="../../assets/images/NewsCenterDetails5_pic1.png" >
        <img class="picimg" src="../../assets/images/NewsCenterDetails5_pic2.png" >
      </div>

        <p class="maintitie">{{ $t('newsCenterDetails5.text5') }}</p>

        <p>{{ $t('newsCenterDetails5.text6') }}</p>

    </div>

    </div>
        <!-- 底部 -->
    <div class="footer"></div>
</div>
</template>

<script>
export default {
  name: "NewsCenterDetails5",
  components: {
    // Tabbar,
  },
  data() {
    return {
    };
  },
  computed: {},
  created() {},
  methods: {},

};
</script>

<style lang="scss" scoped>
.NewsCenterDetails
{
    color: #000;
    width: 100%;
}

.titletext
{
  font-family: "OPPO-B";
  max-width: 990px;
  line-height: 60px;
  font-size: 42px;
  text-align: center;
}

.main
{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
}

.textlayout
{
  display: flex;
  align-items: center;
  justify-content: center;
}
.maincontent
{
  max-width: 990px;
   text-indent: 32px;
   text-align:justify;
   width: 100%;
   line-height: 32px;
   p{
    font-family:"OPPO-R";
    font-size: 16px;
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
    margin-top: 40px;
    margin-bottom: 40px;
   }
}

.timeandaddress
{
    color: #909399;
    margin-top: 37px;
    font-family: "OPPO-R";
    font-size: 1rem;
}

.iconimg
{
    width: 17px;
    height: auto;
    position:relative;
    top: 2px;
}

// 图片
.picimg
{
    width: 435px;
    height: auto;
    margin-top: 40px;
    margin-left: 20px;
}

.footer
{
  margin-top: 120px;
}

@media (max-width: 768px) {
  .titletext
{
  width: 90%;
}
.textlayout
{
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}
.main
{
  display: flex;
  flex-wrap: wrap;
}
.maincontent
{
   text-indent: 32px;
   font-family: "OPPO-R";
   font-size: 17px;
   line-height: 32px;
   width: 90%;

   p{
    font-family:"OPPO-R";
    font-size: 16px;
    
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
    margin-top: 40px;
   }
}

.picimg
{
    width: 90%;
    height: auto;
    margin-top: 29px;
    margin-left: 0px;
}

.footer
{
  margin-top: 40px;
}
.video
{
  width: 90%;
  height: auto;
  margin-top: 40px;
}
}
</style>